module.exports = "../images/walleye-schooling-habits@2x.jpg?v=a8db26f";